<template>
  <video
    ref="video"
    class="monitor-player"
    autoplay
    controls
    :src="stream.hls"
  ></video>
</template>

<script>
import hlsLoader from '@/lib/hls'

export default {
  props: {
    device: {
      type: Object,
      default() {
        return {}
      }
    },
    token: String,
    width: Number,
    height: Number
  },
  data() {
    return {
      HlsClass: null,
      hls: null,
      stream: {}
    }
  },
  async mounted() {
    const Hls = await hlsLoader()
    this.HlsClass = Hls
    if (this.device.deviceId) {
      this.init(this.device)
    }
  },
  methods: {
    clear() {
      return new Promise(resolve => {
        this.hls.on(this.HlsClass.Events.MEDIA_DETACHED, () => {
          this.hls = null
          resolve()
        })
        this.hls.destroy()
      })
    },
    async init(dev) {
      if (this.hls) {
        await this.clear()
      }
      if (this.HlsClass.isSupported()) {
        this.hls = new this.HlsClass()
        this.hls.on(this.HlsClass.Events.MANIFEST_PARSED, () => {
          setTimeout(() => {
            this.$refs.video.play()
          }, 500)
        })
        this.getStream(dev)
      }
    },
    getStream(dev) {
      if (this.hls) {
        const source = dev && dev.streams[0].hls
        this.hls.loadSource(source)
        this.hls.attachMedia(this.$refs.video)
      }
    }
  },
  watch: {
    device(d) {
      this.$nextTick(() => {
        this.init(d)
      })
    }
  }
}
</script>

<style lang="css" scoped>
.monitor-player {
  width: 100%;
  height: 100%;
}
</style>
